import { Skeleton, CardContent, Card } from '@mui/material';

export default function PropertyCard() {
    return (
        <>
            <Card>
                <Skeleton sx={{ height: 200 }} animation="wave" variant="rectangular" />
                <CardContent>
                    <Skeleton animation="wave" height={20} width="100%" />
                    <Skeleton animation="wave" height={15} style={{ marginBottom: 16 }} />
                </CardContent>
            </Card>
        </>
    )
}

